import {getContext, hasContext, setContext} from 'svelte';

export function createContext<T>(contextKey: symbol, ctx: T): T {
    return setContext<T>(contextKey, ctx);
}

export function getContextOrThrow<T>(contextKey: symbol): T {
    if (!hasContext(contextKey)) {
        throw new Error(`Context ${contextKey.description} does not exist! Use 'createContext' function to create it in a parent component.`);
    }

    return getContext<T>(contextKey);
}